import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-channel-push",
  "use": "app-channel-push-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-channel-push\"><path d=\"M17 19v8.357A3.643 3.643 0 0113.357 31H4.644A3.644 3.644 0 011 27.357V6.644A3.645 3.645 0 014.644 3H8M1 25h16M27 1H16a4 4 0 00-4 4v6a4 4 0 004 4h5v5l5-5h1a4 4 0 004-4V5a4 4 0 00-4-4zM16.5 7.5a.5.5 0 100 1 .5.5 0 000-1zm5 0a.5.5 0 100 1 .5.5 0 000-1zm5 0a.5.5 0 100 1 .5.5 0 000-1z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/app-channel-push.svg
// module id = q2Nl
// module chunks = 39 44